__turbopack_context__.v({
  "logoArea": "zAeFDa_logoArea",
  "logoImageHolder": "zAeFDa_logoImageHolder",
  "logoImageHolderMen": "zAeFDa_logoImageHolderMen",
  "simple-logo-mobile": "zAeFDa_simple-logo-mobile",
});
